module.exports = __webpack_public_path__ + "media/images/soar/site/resources_1-c45a76e9959686380f11f699eac2c94c.svg";